// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { AjaxWrapper } from '../Core/AjaxWrapper';
import { OverlayFactory } from './OverlayFactory';
import { IGeognoSisState, IRootState } from '../../../../CommonScripts/Abstractions';
import { Module } from 'Vuex';

const theState: IGeognoSisState = {
    overlays: null,
    sessionId: null,
    geognoSisLayerId: null,
    layerEpsgCode: null,
    groups: null,
    tileSize: null,
    sessionTimeout: null,
    layerIndexPrefix: null,
    singleTile: false,
    opacity: 1,
    extent: undefined
};

const  overlayState: Module<IGeognoSisState, IRootState > = {
    namespaced: true,
    state: theState,
    actions: {
        getOverlaysFromServer(context, payload) {
            var promise = null;
            if (context.state.overlays) {
                promise = context.state.overlays;
            }
            else {
                var ajax = new AjaxWrapper(context.rootState.ajaxDefaults);
                var factory = new OverlayFactory(context.state.sessionId, ajax, context.rootState.baseUrl, context.rootState.mapName, context.state.geognoSisLayerId);
                promise = factory.getOverlays().
                    then(response => {
                        context.commit('setOverlays', response);
                        return response;
                    });
            }
            return promise;
        },
        initialiseGeognoSIS(context) {
            var ajax = new AjaxWrapper(context.rootState.ajaxDefaults);

            return ajax.post(`${context.rootState.baseUrl}GeognoSis/${context.rootState.mapName}/${context.state.geognoSisLayerId }/Sessions`, null, null)
                .then(response => {
                    context.commit('setSessionId', response.data.sessionId);
                    context.commit('setLayerEpsgCode', `EPSG:${response.data.mapProperties.epsgCode}`);
                    context.commit('setGroups', response.data.mapProperties.groups);
                    context.commit('setTimeOut', response.data.timeout);

                    return response;
                });
        },
        createInternalLayer(context, params) {
            var ajax = new AjaxWrapper(context.rootState.ajaxDefaults);
            var factory = new OverlayFactory(context.state.sessionId, ajax, context.rootState.baseUrl, context.rootState.mapName, context.state.geognoSisLayerId);
            return factory.createInternalLayer(params.overlayProperties, params.name)
                .then((response) => {
                    context.commit('addOverlay', response);
                    return response;
                });
        }
    },
    mutations: {
        setOverlays(state, overlays) {
            state.overlays = overlays;
        },
        setSessionId(state, sessionId) {
            state.sessionId = sessionId;
        },
        setGeognoSisLayerId(state, geognoSisLayerId) {
            state.geognoSisLayerId = geognoSisLayerId;
        },
        setLayerEpsgCode(state, layerEpsgCode) {
            state.layerEpsgCode = layerEpsgCode;
        },
        setGroups(state, groups) {
            state.groups = groups;
        },
        addOverlay(state, overlay) {
            if (state.overlays)
                state.overlays.push(overlay);
            else
                state.overlays = [overlay];
        },
        sortOverlays(state) {
            const overlays = [...state.overlays];
            overlays.sort((a, b) => a.overlayIndex - b.overlayIndex);
            state.overlays = overlays;
        },
        removeOverlay(state, overlay) {
            const foundIdx = state.overlays.findIndex((item) => {
                return item === overlay;
            });
            if (foundIdx !== -1) {
                state.overlays.splice(foundIdx, 1);
                for (let c = foundIdx; c < state.overlays.length; c++) {
                    state.overlays[c].overlayIndex =  state.overlays[c].overlayIndex - 1;
                }
            }
        },
        setTileSize(state, size: number[]) {
            state.tileSize = size;
        },
        setTimeOut(state, timeout: number) {
            state.sessionTimeout = timeout;
        },
        setLayerIndexPrefix(state, value: string) {
            state.layerIndexPrefix = value; 
        },
        setSingleTile(state, value: boolean): void {            
            state.singleTile = value;
        },
        setOpacity(state, value: number): void {
            state.opacity = value;
        },
        setExtent(state, value: Array<number> | undefined): void {
            state.extent = value;
        }
    },
    getters: {
        sessionTimeout: state => {
            return state.sessionTimeout;
        },
        layerIndexPrefix: state => {
            return state.layerIndexPrefix;
        },
        getSingleTile(state: IGeognoSisState): boolean {           
            return state.singleTile;
        },
        getOpacity(state: IGeognoSisState): number {
            return state.opacity;
        },
        getExtent(state: IGeognoSisState): Array<number> | undefined {
            return state.extent;
        }
    }
};
export default overlayState;

